module.exports = __webpack_public_path__ + "static/media/teafloor3.5980a023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor3.jpg
// module id = 454
// module chunks = 0